import React from 'react'

function EventNotificationPopup() {
  return (
    <div></div>
  )
}

export default EventNotificationPopup